import React from 'react';
import { Icon, IconProps } from '~web/view/components/ui/icon.component';

export const EditIcon: React.FunctionComponent<IconProps> = ({
  width = 25,
  height = 25,
  ...rest
}) => (
  <Icon width={width} height={height} viewBoxWidth={25} viewBoxHeight={25} {...rest}>
    <path d="M24.3199 5.53309L21.8107 8.04228L16.6636 2.89522L19.1728 0.386029C19.4301 0.128676 19.7518 0 20.1379 0C20.5239 0 20.8456 0.128676 21.1029 0.386029L24.3199 3.60294C24.5772 3.86029 24.7059 4.18199 24.7059 4.56801C24.7059 4.95404 24.5772 5.27574 24.3199 5.53309ZM0 19.5588L15.1838 4.375L20.3309 9.52206L5.14706 24.7059H0V19.5588Z" />
  </Icon>
);



// WEBPACK FOOTER //
// /codebuild/output/src332225586/src/modules/web/src/js/view/components/ui/icon/edit.icon.tsx